import React, { memo } from 'react'
import { Icon, Text } from 'common-components'
import ArrowDownIcon from 'assets/svgr-icons/Arrow_Down.svg'
import CrownIcon from 'assets/svgr-icons/Crown.svg'
import * as Styled from './styled'
import CapabilityChips from '../CapabilityChips'
import { IModelGroup } from '../types'
import { getProviderInitials } from '../utils'

interface IProps {
  group: IModelGroup
  labels: string[]
  isActive: boolean
  isSelected: boolean
  isMultiVariant: boolean
  isPremium: boolean
  onClick: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  triggerRef: (el: HTMLDivElement | null) => void
}

const GroupRow: React.FC<IProps> = ({
  group,
  labels,
  isActive,
  isSelected,
  isMultiVariant,
  isPremium,
  onClick,
  onMouseEnter,
  onMouseLeave,
  triggerRef
}) => {
  return (
    <Styled.GroupItemWrapper
      ref={triggerRef}
      $isActive={isActive}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Styled.GroupItemHeader>
        {group.Icon ? (
          <Icon icon={<group.Icon />} customSize={20} />
        ) : (
          <Styled.ProviderIconFallback>
            {getProviderInitials(group.label)}
          </Styled.ProviderIconFallback>
        )}
        <Styled.GroupItemTitle>
          <Text type={isSelected ? 'subtitle' : 'h2'} color="secondaryDark">
            {group.label}
          </Text>
          {isPremium && (
            <Styled.CrownBadgeIcon
              icon={<CrownIcon />}
              size="small"
              color="goldDark"
            />
          )}
        </Styled.GroupItemTitle>
        {isMultiVariant && (
          <Styled.GroupChevron>
            <Icon icon={<ArrowDownIcon />} customSize={12} color="secondary" />
          </Styled.GroupChevron>
        )}
      </Styled.GroupItemHeader>
      <CapabilityChips labels={labels} />
    </Styled.GroupItemWrapper>
  )
}

export default memo(GroupRow)
